// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip-content[data-v-3540aaf8]{position:absolute;color:#fff;background-color:#000;padding:6px 10px;border-radius:4px;white-space:nowrap;z-index:1000;pointer-events:none}.fade-enter-active[data-v-3540aaf8],.fade-leave-active[data-v-3540aaf8]{transition:opacity .2s}.fade-enter-from[data-v-3540aaf8],.fade-leave-to[data-v-3540aaf8]{opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
